import React, { useState, useRef, useEffect } from 'react'
import "./NavbarUser.scss";
// import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
// import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
// import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
// import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
// import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ContentPasteSearchRoundedIcon from '@mui/icons-material/ContentPasteSearchRounded';
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import GradingIcon from '@mui/icons-material/Grading';
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import LogoutIcon from '@mui/icons-material/Logout';
import { Link, NavLink } from "react-router-dom";
import FetchApi from './../../pages/customhooks/Functionapi';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import Typography from '@mui/material/Typography';
// import Divider from '@mui/material/Divider';
import { Menu, MenuItem, Button, Box, Typography, Chip, Avatar, IconButton, Tooltip, Badge } from "@mui/material";
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';



const NavbarUser = () => {
    //  sessionStorage.setItem("userId",data.data[0].userId)
    const nameUserlogin = sessionStorage.getItem("userName")
    const userId = sessionStorage.getItem("userId")
    const FetchApis = new FetchApi();

    const [menuList, setMuneList] = useState([])
    const [journalPre, setJourmalPre] = useState([])
    const [countPading, setCountPading] = useState([])

    const [countItemgroup, setCountItemgroup] = useState({Previewnotify:0,Pandingnotify:0,
        rejectgroupnotify:0,totalreject:0,totalEditreject:0});
    const[totalgroup,setTotalgroup]=useState(0)
    const[totalsum,setTotalsum]=useState({sumnotify:0})
    const [Itemgroup, setItemgroup] = useState([])

    const [userAll, setUserAll] = useState([])

    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);




    const [anchorEl, setAnchorEl] = useState(null);
    const openOntiry = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };



    const toggleMenu = () => setOpen(!open);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);


    }, []);

    const handleLogout = () => {
        window.location.href = '/'
        setOpen(false);
    };



    React.useEffect(() => {

        FetchApis.FethcGet(`/groupmenudetail/menuListByUserId/${userId}`).then(res => {
            if (res) {

                setMuneList(res.data)
            }
        })

        notifylistJournal();
        notifygroupItem();
        getuserName();
        notifygroupLength();

    }, [])

    async function notifylistJournal() {
        await FetchApis.FethcGet(`/document/warningNotityByUserId/${userId}`).then(res => { // รอ recieved 
         
            if (res.status == 200) {
                setCountPading(res.data.length)
                setJourmalPre(res.data)
                // console.log(res.data)
            }

        })
    }

    async function notifygroupItem() {
        await FetchApis.FethcGet(`/document/notifylistByIdUser/${userId}`).then(res => { // รอ recieved แบบกลุ่ม

            if (res.status == 200) {
                setCountItemgroup(res.data[0])
                let sumall=Number(res.data[0].Previewnotify)+Number(res.data[0].totalreject)+Number(res.data[0].totalEditreject);
                setTotalsum({...totalsum,sumnotify:sumall})
                setItemgroup(res.data)
            }

        })
    }

        async function notifygroupLength() {
        await FetchApis.FethcGet(`/JournalBygroup/NotifygroupByid/${userId}`).then(res => { // รอ recieved แบบกลุ่ม

            if (res.status == 200) {
                // setCountItemgroup(res.data[0])
                
                setTotalgroup(res.data.length)
         
            }

        })
    }

    function getuserName() {
        FetchApis.FethcGet(`/user/userById/${userId}`).then(res => {
            if (res) {
                setUserAll(res.data[0])
            }
        })
    }

    function isClickToLink(jourid,statusType) {
     
        if(statusType=='201'){
            window.location.href = `/editRejectdocument/${jourid}/201`
        }
        else{
           window.location.href = `/viewdocument/${jourid}/112` 
        }
        
    }

    function isClickTolinkitemgroup(jourid) {
        window.location.href = `/recievjournalgroup/${jourid}`
    }

    // ไอคอน + สีประจำของแต่ละเมนู (จับคู่ตาม routepart ที่มาจากฐานข้อมูล)
    const ArrayMenulist = [
        { partment: '/workflow', label: 'Workflow', Icon: TimelineRoundedIcon, color: '#1e88e5' },
        { partment: '/documentApproved', label: 'Document Approved', Icon: DescriptionRoundedIcon, color: '#43a047' },
        { partment: '/documents', label: 'New Document', Icon: NoteAddRoundedIcon, color: '#8e24aa' },
        { partment: '/approvelist', label: 'Approve List', Icon: AssignmentTurnedInRoundedIcon, color: '#ef6c00' },
        { partment: '/journalHistory', label: 'Search History', Icon: ManageSearchRoundedIcon, color: '#00897b' },
        { partment: '/reviseGroup', label: 'Revise Group', Icon: ContentPasteSearchRoundedIcon, color: '#5e35b1' },
        { partment: '/approvedGroup', label: 'Approve Group', Icon: VerifiedUserRoundedIcon, color: '#d81b60' },
    ];

    function getMenuMeta(routepart) {
        return ArrayMenulist.find(m => m.partment == routepart) || { Icon: DescriptionRoundedIcon, color: '#607d8b' };
    }

    function getMenuBadge(menuname) {
        if (menuname == 'APPROVE GROUP') return totalgroup;
        if (menuname == 'APPROVE LIST' || menuname == 'NEW DOCUMENT') return totalsum.sumnotify;
        return 0;
    }

    return (
        <div className="navbar">
            <div className="wrapper">

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Box
                        component={Link}
                        to="/workflow"
                        sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mr: 2.5, textDecoration: 'none' }}
                    >
                        <Box sx={{
                            width: 38, height: 38, borderRadius: 2.5,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: 'linear-gradient(135deg, #43a047 0%, #1e88e5 100%)',
                            boxShadow: '0 4px 10px rgba(30,136,229,0.3)',
                        }}>
                            <AccountTreeRoundedIcon sx={{ color: '#fff', fontSize: 22 }} />
                        </Box>
                        <Box sx={{ lineHeight: 1.1 }}>
                            <Box sx={{ fontWeight: 800, fontSize: 18, color: '#263238', letterSpacing: 0.3 }}>DOCUMENT FLOW</Box>
                            <Box sx={{ fontSize: 11, color: '#90a4ae', letterSpacing: 0.5 }}>E-Spec Document System</Box>
                        </Box>
                    </Box>

                    {menuList.map((item) => {
                        const { Icon, color, label } = getMenuMeta(item.routepart);
                        const badge = getMenuBadge(item.menuname);
                        return (
                            <Box
                                key={item.routepart}
                                component={NavLink}
                                to={item.routepart}
                                sx={{
                                    display: 'flex', alignItems: 'center', gap: 1,
                                    pl: 0.5, pr: 1.5, py: 0.5,
                                    borderRadius: 999,
                                    textDecoration: 'none',
                                    color: '#546e7a',
                                    fontSize: 13.5, fontWeight: 600,
                                    border: '1px solid transparent',
                                    transition: 'background-color .15s, color .15s, border-color .15s',
                                    '& .menu-icon': { bgcolor: `${color}14`, color },
                                    '&:hover': { bgcolor: '#f4f6f9', color: '#263238' },
                                    '&.active': {
                                        bgcolor: `${color}12`,
                                        borderColor: `${color}40`,
                                        color,
                                        '& .menu-icon': { bgcolor: color, color: '#fff' },
                                    },
                                }}
                            >
                                <Box className="menu-icon" sx={{
                                    width: 28, height: 28, borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    transition: 'background-color .15s, color .15s',
                                }}>
                                    <Icon sx={{ fontSize: 17 }} />
                                </Box>
                                <Box component="span" sx={{ whiteSpace: 'nowrap' }}>{label || item.menuname}</Box>
                                {badge > 0 && (
                                    <Box component="span" sx={{
                                        minWidth: 20, height: 20, px: 0.6, borderRadius: 999,
                                        bgcolor: '#e53935', color: '#fff',
                                        fontSize: 11, fontWeight: 700,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        {badge > 99 ? '99+' : badge}
                                    </Box>
                                )}
                            </Box>
                        );
                    })}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>

                    <Tooltip title="แจ้งเตือน" arrow>
                        <IconButton
                            onClick={handleOpen}
                            sx={{
                                width: 42, height: 42,
                                border: '1px solid #e3e6ea',
                                bgcolor: openOntiry ? '#eef4ff' : '#fff',
                                color: '#455a64',
                                '&:hover': { bgcolor: '#f4f6f9' },
                            }}
                        >
                            <Badge
                                badgeContent={countPading}
                                color="error"
                                max={99}
                                sx={{ '& .MuiBadge-badge': { fontWeight: 700, fontSize: 10, minWidth: 18, height: 18, border: '2px solid #fff' } }}
                            >
                                <NotificationsNoneRoundedIcon />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <div>
                        <Menu
                            anchorEl={anchorEl}
                            open={openOntiry}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            sx={{ marginTop: 1 }}
                            slotProps={{
                                paper: {
                                    sx: {
                                        width: 380,
                                        borderRadius: 3,
                                        overflow: 'hidden',
                                        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.16)',
                                        border: '1px solid #e3e6ea',
                                    },
                                },
                            }}
                            MenuListProps={{ sx: { p: 0 } }}
                        >
                            <Box sx={{
                                px: 2, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                background: 'linear-gradient(135deg, #f4f6f9 0%, #eef4ff 100%)',
                                borderBottom: '1px solid #e3e6ea',
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <NotificationsNoneOutlinedIcon sx={{ color: '#37474f' }} />
                                    <Typography sx={{ fontWeight: 700, color: '#37474f', fontSize: 16 }}>แจ้งเตือน</Typography>
                                </Box>
                                <Chip
                                    size="small"
                                    label={`${journalPre.length} รายการ`}
                                    sx={{ bgcolor: journalPre.length > 0 ? '#fdecea' : '#eceff1', color: journalPre.length > 0 ? '#d32f2f' : '#607d8b', fontWeight: 600 }}
                                />
                            </Box>

                            <Box sx={{ maxHeight: 420, overflowY: 'auto' }}>
                                {journalPre.length === 0 && (
                                    <Box sx={{ py: 5, textAlign: 'center', color: '#90a4ae' }}>
                                        <NotificationsNoneOutlinedIcon sx={{ fontSize: 40, mb: 1 }} />
                                        <Typography sx={{ fontSize: 14 }}>ไม่มีรายการแจ้งเตือน</Typography>
                                    </Box>
                                )}
                                {journalPre.map((item) => {
                                    const isReject = item.statusflow == '201';
                                    return (
                                        <MenuItem
                                            key={item.JournalID}
                                            onClick={() => { handleClose(); isClickToLink(item.JournalID, item.statusflow); }}
                                            sx={{
                                                px: 2, py: 1.25, gap: 1.5, alignItems: 'center',
                                                borderBottom: '1px solid #f1f3f5',
                                                '&:hover': { backgroundColor: '#eef4ff' },
                                            }}
                                        >
                                            <Avatar sx={{
                                                width: 36, height: 36,
                                                bgcolor: isReject ? '#fdecea' : '#e3f2fd',
                                                color: isReject ? '#d32f2f' : '#1565c0',
                                            }}>
                                                <DescriptionIcon fontSize="small" />
                                            </Avatar>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#263238' }}>
                                                    {item.JournalCode}
                                                </Typography>
                                                <Typography noWrap sx={{ fontSize: 12, color: '#78909c' }}>
                                                    {item.ItemName || '-'}{item.createBy ? ` · ${item.createBy}` : ''}
                                                </Typography>
                                            </Box>
                                            <Chip
                                                size="small"
                                                label={isReject ? 'แก้ไข' : 'รอรับงาน'}
                                                sx={{
                                                    height: 22, fontSize: 11, fontWeight: 600,
                                                    bgcolor: isReject ? '#fdecea' : '#fff4e5',
                                                    color: isReject ? '#d32f2f' : '#ef6c00',
                                                }}
                                            />
                                        </MenuItem>
                                    );
                                })}
                            </Box>
                            {/* <Divider />
                            <MenuItem>
                                <label>แจ้งเตือนเอกสารกลุ่ม ({countItemgroup})</label>
                            </MenuItem>
                            {Itemgroup.map((item, index) => (
                                <MenuItem>
                                    <div onClick={() => isClickTolinkitemgroup(item.journalGroupID)}>{item.journalGroupID}</div>
                                </MenuItem>
                            ))
                            } */}

                        </Menu>
                    </div>

                    <Box sx={{ position: 'relative' }} ref={menuRef}>
                        <Box
                            onClick={toggleMenu}
                            sx={{
                                display: 'flex', alignItems: 'center', gap: 1,
                                pl: 0.5, pr: 1, py: 0.5,
                                borderRadius: 999,
                                border: '1px solid',
                                borderColor: open ? '#90caf9' : '#e3e6ea',
                                bgcolor: open ? '#eef4ff' : '#fff',
                                cursor: 'pointer',
                                transition: 'background-color .15s, border-color .15s, box-shadow .15s',
                                '&:hover': { bgcolor: '#f4f6f9', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
                            }}
                        >
                            <Avatar sx={{ width: 32, height: 32, fontSize: 15, fontWeight: 700, background: 'linear-gradient(135deg, #43a047 0%, #1e88e5 100%)' }}>
                                {(nameUserlogin || '?').trim().charAt(0)}
                            </Avatar>
                            <Box sx={{ fontSize: 14, fontWeight: 600, color: '#37474f', whiteSpace: 'nowrap' }}>คุณ {nameUserlogin}</Box>
                            <KeyboardArrowDownRoundedIcon sx={{ fontSize: 20, color: '#78909c', transition: 'transform .2s', transform: open ? 'rotate(180deg)' : 'none' }} />
                        </Box>

                        {open && (
                            <Box sx={{
                                position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 100,
                                width: 280, bgcolor: '#fff',
                                borderRadius: 3, overflow: 'hidden',
                                border: '1px solid #e3e6ea',
                                boxShadow: '0 12px 32px rgba(15, 23, 42, 0.16)',
                            }}>
                                <Box sx={{
                                    display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 2,
                                    background: 'linear-gradient(135deg, #f4f6f9 0%, #eef4ff 100%)',
                                    borderBottom: '1px solid #e3e6ea',
                                }}>
                                    <Avatar sx={{ width: 46, height: 46, fontSize: 20, fontWeight: 700, background: 'linear-gradient(135deg, #43a047 0%, #1e88e5 100%)' }}>
                                        {(userAll.name || nameUserlogin || '?').trim().charAt(0)}
                                    </Avatar>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Box sx={{ fontWeight: 700, fontSize: 15, color: '#263238' }}>คุณ {userAll.name}</Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: 12, color: '#78909c', minWidth: 0 }}>
                                            <MailOutlineRoundedIcon sx={{ fontSize: 14 }} />
                                            <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{userAll.email || '-'}</Box>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    <Box sx={{ width: 32, height: 32, borderRadius: 2, bgcolor: '#e8f5e9', color: '#43a047', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <BadgeRoundedIcon sx={{ fontSize: 18 }} />
                                    </Box>
                                    <Box>
                                        <Box sx={{ fontSize: 11, color: '#90a4ae' }}>รหัสพนักงาน</Box>
                                        <Box sx={{ fontSize: 14, fontWeight: 600, color: '#37474f' }}>{userAll.employeeId || '-'}</Box>
                                    </Box>
                                </Box>

                                <Box sx={{ borderTop: '1px solid #f1f3f5', p: 1 }}>
                                    <Box
                                        component="button"
                                        onClick={handleLogout}
                                        sx={{
                                            width: '100%', display: 'flex', alignItems: 'center', gap: 1.5,
                                            px: 1.5, py: 1, border: 'none', borderRadius: 2,
                                            bgcolor: 'transparent', color: '#d32f2f',
                                            fontSize: 14, fontWeight: 600, fontFamily: 'inherit',
                                            cursor: 'pointer', textAlign: 'left',
                                            '&:hover': { bgcolor: '#fdecea' },
                                        }}
                                    >
                                        <LogoutRoundedIcon sx={{ fontSize: 20 }} />
                                        ออกจากระบบ
                                    </Box>
                                </Box>
                            </Box>
                        )}
                    </Box>

                </Box>
            </div >
        </div >
    )
}

export default NavbarUser